import { setupSlideshow, lazyLoad, displayBlock, smoothScroll, childMenu, menuOverlay, setupModalVideo, setupProductFacet} from './functions'
//import StickySidebar from 'sticky-sidebar'
import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar'
import './polyfill'
import $ from 'jquery'

//SIDEBAR LINK COLOR CHANGE
$('.nav__link').click(function() {
  $(this).siblings().removeClass('link-warm').addClass('link-cold');
  $(this).addClass('link-warm').removeClass('link-cold');
});

//NEWSLETTER FORM ADJUSTMENTS
const $parent = $('.widget.module');
const $form = $('.widget.module > form').addClass( "newsletter-form" );
$form.parent().after($form);
$parent.hide();


/* RETE COMMERCIALE FILTER
  ----------------------------- */
$(document).on('facetwp-loaded', function() {
  $('.network').addClass('visible')
})

 /* STICKY SIDEBAR
   ----------------------------- */
const stickySidebar = () => {
  if($('.product__nav').length > 0) {
    const sidebar = new StickySidebar('.product__nav', {
      topSpacing: 50,
      bottomSpacing: 0,
      containerSelector: '.wrapper',
      innerWrapperSelector: '.sidebar__inner',
    })
  }
}

window.onload = () => {
  setupSlideshow('.section__slideshow', 'fullwidth')
  setupSlideshow('.section__slide--main', 'references')
  setupSlideshow('.section__slide--nav', 'nav')
  setupSlideshow('.section__events .section__list', 'fullwidth')
  lazyLoad()
  childMenu()
  smoothScroll()
  displayBlock()
  menuOverlay()
  stickySidebar()
  setupModalVideo()

  const bodyClasses = $('body').attr("class").split(/\s+/)

  $.each(bodyClasses, function(key, value) {
    switch(value) {
      case "post-type-archive":
        setupProductFacet()
        break
      case "archive":
        FWP.refresh()
        break
      default:
        //project.imageFadeIn()
        $('#loader').fadeOut(500)
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/main.js